var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { observable, action, computed } from "mobx";
import { parseTimeFull } from "sb-helpers";
export class LiveGameState {
    constructor(data) {
        this.clockRunning = data.clockRunning;
        this.clockDirection = data.clockDirection;
        this.gameTime = data.gameTime;
        this.gamePart = data.gamePart;
    }
    update(data) {
        if (this.shouldUpdateGameTime(data)) {
            this.gameTime = data.gameTime;
        }
        this.gamePart = data.gamePart;
        this.clockDirection = data.clockDirection;
        this.clockRunning = data.clockRunning;
    }
    updateGameTime(gameTime) {
        this.gameTime = gameTime;
    }
    get formattedTime() {
        if (this.gameTime !== -1) {
            return parseTimeFull(this.gameTime);
        }
        return "";
    }
    // as the api dosn't provide a timestamp for calculation the delta
    // this hack prevents from jumps of the clock on every update
    shouldUpdateGameTime(data) {
        return !data.clockRunning || !this.gameTime || !data.gameTime || data.gameTime > this.gameTime;
    }
}
__decorate([
    observable,
    __metadata("design:type", Number)
], LiveGameState.prototype, "gameTime", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], LiveGameState.prototype, "gamePart", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], LiveGameState.prototype, "update", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], LiveGameState.prototype, "updateGameTime", null);
__decorate([
    computed,
    __metadata("design:type", String),
    __metadata("design:paramtypes", [])
], LiveGameState.prototype, "formattedTime", null);
//# sourceMappingURL=LiveGameState.js.map